<div class="fs-2 with-close" mat-dialog-title>
    Vous devez vraiment apprécier LyBox !
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <img class="img-fluid mt-3 mb-3" src="assets/upgrade/annonce.png"><br/>
    <p *ngIf="plan == 'basique'">Vous avez déjà 10 annonces enregistrées en favoris, ce qui correspond à la limite de votre forfait Basique.</p>
    <p *ngIf="plan == 'essentiel'">Vous avez déjà 50 annonces enregistrées en favoris, ce qui correspond à la limite de votre forfait Essentiel.</p>
    <b *ngIf="plan == 'basique'">Passez sur un forfait Essentiel pour pouvoir enregistrer jusqu’à 50 annonces dés maintenant.</b>
    <b *ngIf="plan == 'essentiel'">Passez sur un forfait Expert pour pouvoir enregistrer vos annonces sans limites.</b>
</div>
<div mat-dialog-actions>
    <a type="button" (click)="onYesClick()" class="btn btn-info w-100">
        Débloquer plus de favoris
    </a>
</div>
